import { useState, type FormEvent } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { auth } from '../api/endpoints';
import { ApiError } from '../api/client';

const MIN_LENGTH = 12;

export function Reset() {
  const loc = useLocation();
  const nav = useNavigate();
  const token = new URLSearchParams(loc.search).get('token');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (!token) {
    return (
      <div className="login">
        <div className="card">
          <h1>Proofroom</h1>
          <p className="sub">This reset link has no token. Ask for a new one.</p>
        </div>
      </div>
    );
  }

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    if (password.length < MIN_LENGTH) { setError(`Password must be at least ${MIN_LENGTH} characters`); return; }
    if (password !== confirm) { setError('Passwords do not match'); return; }
    setBusy(true);
    try {
      await auth.reset(token, password);
      nav('/login', { replace: true });
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Reset failed');
    } finally { setBusy(false); }
  };

  return (
    <div className="login">
      <form className="card" onSubmit={submit}>
        <h1>Proofroom</h1>
        <p className="sub">Choose a new password</p>
        <div className="field">
          <label className="label" htmlFor="password">New password</label>
          <input id="password" className="input" type="password" autoComplete="new-password" value={password} onChange={(e) => setPassword(e.target.value)} required autoFocus />
        </div>
        <div className="field">
          <label className="label" htmlFor="confirm">Confirm password</label>
          <input id="confirm" className="input" type="password" autoComplete="new-password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required />
        </div>
        {error && <p className="error-text" role="alert" style={{ marginBottom: 12 }}>{error}</p>}
        <button className="btn primary" type="submit" disabled={busy} style={{ width: '100%', height: 36, justifyContent: 'center' }}>{busy ? 'Resetting' : 'Reset password'}</button>
      </form>
    </div>
  );
}
